import { checkEnumValue, defineDirective, fields, IModule, IOmniaShell, OmniaModuleId, shell } from "./omnia"
import { ISoilModuleContext, ISoilService } from "./types"

export enum AnalysisView {
    Table = "table",
    Map = "map",
    Plan = "plan"
}

export class SoilCtrl extends shell.Module implements ISoilModuleContext {

    static create(): ng.IDirective {

        return defineDirective(SoilCtrl, "app/soil/soil.html")

    }

    static $inject = ["$scope", "OmniaSoilService", "OmniaShell"]

    views: typeof views = []
    disableViewSelector = false
    private _view: AnalysisView

    constructor($scope: ng.IScope, private _svc: ISoilService, shell: IOmniaShell) {

        super($scope, shell, "icon-soil-analysis", "Soil analysis", OmniaModuleId.Soil)

        this.views = setupViews(shell)

    }

    $onInit() {

        this._filter = fields.createFilter(this.svc.fieldSvc)

        this.startFunction(() => this.setInitialView(), () => this.refresh())

    }

    refresh() {
        return this.svc.refresh()
    }

    private setInitialView() {
        const s: AnalysisView = this.svc.settings.get("mainView")
        this.view = checkEnumValue(AnalysisView, s) ? s : AnalysisView.Map
    }

    get svc(): ISoilService {
        return this._svc
    }

    get module(): IModule {
        return this
    }

    get view() {
        return this._view
    }

    set view(view) {
        this._view = view
        this.svc.settings.set("mainView", view)
    }

}


const views = [{ id: 'table', text: 'Table' }, { id: 'map', text: 'Map' }, { id: 'plan', text: 'Plan' }]

function setupViews(shell: IOmniaShell) {

    const perm = shell.getSession()?.permissions
    const plans = perm?.soilManagementPlan

    return plans
        ? views
        : views.filter(v => v.id !== "plan")

}
